// extracted by mini-css-extract-plugin
export default {"hero":"WLUmrC","freshRecipeList":"iKGtr9","freshRecipeListItem":"vrUQOW","recipeImage":"YI44aw","diyImage":"lsUAOz"};